<template src="./DashboardDoctor.html" lang="html"></template>

<script>
import mixins from "../../../../Mixins.js";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
export default {
  mixins: [mixins],
  components: {
    ECharts
  },
  data() {
    return {
      pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "Solicitação de consultas",
            "Consultas agendadas",
            "Consultas finalizadas",
            "Atendimentos Não finalizados",
            "Pacientes atendidos"
          ]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            color: ["#FF0000", "#508cc8", "#3c6997", "#78c8be", "#fd7e14"],
            data: [
              { value: 1, name: "Solicitação de consultas" },
              { value: 2, name: "Consultas agendadas" },
              { value: 3, name: "Consultas finalizadas" },
              { value: 4, name: "Atendimentos Não finalizados" },
              { value: 5, name: "Pacientes atendidos" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      confirmed: 0,
      concluded: 0,
      waitingMatch: 0,
      pendingMedicalAppointment: 0,
      pendingMedicalRecord: 0,
      patientsAttended: 0,
      appointments: [],
      concludedAppointments: []
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getConfirmed();
      vm.getHistoryConcluded();
      vm.getPendency();
    },
    getConfirmed() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/appointments?status=CONFIRMED&page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            options: {
              page: 0,
              size: 10,
              sort: ["id", "desc"]
            }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.confirmed = response.data.totalElements;
            vm.updateChart();
          }
        });
    },
    getHistoryConcluded() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records?page=0&size=50&sort=id",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            options: {
              page: 0,
              size: 10,
              sort: ["id", "desc"]
            }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.appointmentsconcludedAppointments = response.data.content;
            vm.patientsAttended = response.data.totalElements;
            let concluded = vm.appointmentsconcludedAppointments.filter(
              function(item) {
                return item.status.type !== "PENDENT";
              }
            );
            vm.concluded = concluded.length;
            vm.updateChart();
          }
        });
    },
    getPendency() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/pendency?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.pendingMedicalAppointment = response.data.content.length;
            if(vm.pendingMedicalAppointment){
               vm.fillCards();
            }        
          }
        });
    },
    updateChart() {
      const vm = this;

      vm.pie.series[0].data = [
        { value: vm.pendingMedicalRecord, name: "Solicitação de consultas" },
        { value: vm.confirmed, name: "Consultas agendadas" },
        { value: vm.concluded, name: "Consultas finalizadas" },
        { value: vm.pendingMedicalAppointment, name: "Atendimentos Não finalizados" },
        { value: vm.patientsAttended, name: "Pacientes atendidos" }
      ];
    }
  }
};
</script>

<style src="./DashboardDoctor.scss" lang="scss">
</style>